import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MatIconRegistry } from '@angular/material/icon';

import { FsOffline } from '@firestitch/offline';
import { FsProgressModule } from '@firestitch/progress';
import { FsWebSocket } from '@firestitch/web-socket';

import { AppService, BeaconService, SessionService } from './core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FsProgressModule, RouterOutlet],
})
export class AppComponent {

  // Timer service injected here to construct service on app init. Don't remove
  // Global Drawer service injected here to construct service on app init. Don't remove
  constructor(
    private _offline: FsOffline,
    private _appService: AppService,
    private _beaconService: BeaconService,
    private _fsWebSocket: FsWebSocket,
    private _iconRegistry: MatIconRegistry,
    private _sessionService: SessionService,
  ) {
    this._offline.init();
    this._appService.init();
    this._beaconService.init();
    this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');


    if (this._appService.settings.websocketEnabled) {
      this._sessionService.account$()
        .subscribe((store: any) => {
          if (store) {
            this._fsWebSocket.connect();
          } else {
            this._fsWebSocket.disconnect();
          }
        });
    }
  }

}
